import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {AventuraService} from "../../../services/api/aventura.service";
import {FileService} from "../../../services/api/file.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-dialog-asignar-equipos',
  templateUrl: './dialog-asignar-equipos.component.html',
  styleUrls: ['./dialog-asignar-equipos.component.css']
})
export class DialogAsignarEquiposComponent implements OnInit {

  loading:boolean=true;

  dataSource:any;

  articulos:any;

  displayedColumns: string[] = [
    'Check',
    'nombre',
    'categoria',
    'marca',
    'modelo',
    'talla',
    'observacion',
    'valoracion',
    'estado'

  ];

  file:any

  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  //@ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private fileService: FileService,private aventuraService: AventuraService,@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DialogAsignarEquiposComponent>) { }

  ngOnInit(): void {
    console.log(this.data.file)
    this.getAllEquipos()
  }

  getAllEquipos() {
    this.aventuraService.getAllEquiposInventario().subscribe((response:any) => {
      this.articulos = response.getAllEquiposInventario;

      this.fileService.getItineraryEquipos(this.data.file.idItinerary).subscribe((res:any)=>{
        console.log(res)
        this.file=res.getItinerary

        this.file.equipos?.map((el:any)=>{
          this.articulos.map((art:any,index:any)=>{
            if(el.id===art.id){
              art.checked = true
              let removedItems=this.articulos.splice(index,1)
              this.articulos.unshift(...removedItems)
            }

          })
        })

        this.dataSource=new MatTableDataSource(this.articulos)
        this.dataSource.paginator=this.paginator

        this.loading=false

      })


    });

  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.articulos.map((fila: any) => {
        fila.checked = false;
      });
      return;
    } else {
      this.articulos.map((fila: any) => {
        fila.checked = true;
      });
      return;
    }
  }

  isAllSelected() {
    let lst: any[];
    lst = this.articulos.filter((x: any) => x.checked == true);
    const numSelected = lst.length;
    const numRows = this.articulos.length;
    return numSelected === numRows;
  }

  updateCheck(row: any) {
    console.log(row)
    row.checked = !row.checked;

  }

  closeDialog() {

    const equipos=this.dataSource.data.filter((el:any)=>el.checked)

    console.log(equipos)
    console.log(this.data)

    equipos.map((el:any)=>{
      delete el.checked
      delete el.factura
      delete el.codigo
      delete el.fileAsignado
    })
    console.log(equipos)

    this.aventuraService.updateFileEquipos(this.file.id,equipos).subscribe((data:any)=>{
      console.log("updatedEquipoDone");
      console.log(data)
      Swal.fire({
          position: 'top-end',
          title: 'Los equipos se asignaron satisfactoriamente',
          icon:"success",
          showConfirmButton: false,
          timer: 5000
        }
      )
      this.dialogRef.close(equipos);
    })


  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


}
